import { createProvider } from '../../utils/createProvider';
import { TabsProviderValue } from './types';

export const URL_TAB_NAME_HASH_KEY = 'tab';

export enum TabsRole {
	TabList = 'tabList',
	Tab = 'tab',
	TabPanel = 'tabPanel',
}

const [TabsContextProvider, useTabsProvider] = createProvider<TabsProviderValue>({
	contextName: 'TabsContext',
	// hot fix of bug #34484, todo: either remove "useTabsProvider" from "useFallbackTab" or make sure all "Tabs" components are wrapped with "TabsProvider"s
	strict: false,
});

export { TabsContextProvider, useTabsProvider };
